module.exports = __webpack_public_path__ + "static/media/FlatBedTruckIcon.b165a903.svg";